export { default as ShippingMethodsSkeleton } from "./ShippingMethodsSkeleton";
